module.exports = __webpack_public_path__ + "static/media/7.7f3e6c02.gif";